import { MostUsedWasteCode } from "api/wasteCode.api";
import { ComboBoxItem } from "components/ComboBox";

interface Props {
  mostUsedWasteCodes?: MostUsedWasteCode[];
  selectedWasteCode?: ComboBoxItem;
  onSelectWasteCode: (wasteCode: any) => void;
}

export const MostUsedWasteCodePills = ({
  mostUsedWasteCodes,
  selectedWasteCode,
  onSelectWasteCode,
}: Props) => {
  if (!mostUsedWasteCodes || mostUsedWasteCodes.length === 0) {
    return null;
  }

  return (
    <div className="mb-3">
      {/* <p className="text-sm font-medium text-gray-700 mb-2">
        Vanligaste avfallskoder:
      </p> */}
      <div className="flex flex-wrap gap-2">
        {mostUsedWasteCodes.map((item) => (
          <button
            key={item.wasteCode.uuid}
            type="button"
            onClick={() => onSelectWasteCode(item.wasteCode)}
            className={`rounded-full border px-3 py-1 text-sm transition-colors ${
              selectedWasteCode?.id === item.wasteCode.uuid
                ? "border-cyan-600 bg-cyan-600 text-white"
                : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {item.wasteCode.codePretty}
          </button>
        ))}
      </div>
    </div>
  );
};
